<template>
  <div style="margin-top: 5px">
    <div
        class="search-input"
        style="margin-bottom: -20px; position: relative; z-index: 1"
    >
      <!-- input of detail -->
      <div v-if="visibleDetailDate">
        <el-date-picker
            class="input-common input-date"
            style="width: 135px"
            v-model="dataSearch.date"
            type="date"
            :clearable="false"
            format="dd-MM-yyyy"
            value-format="yyyy-MM-dd"
            placeholder="Chọn ngày"
            :picker-options="startDayOfWeek"
            @change="getSearchAllAttendanceDetail()"
        ></el-date-picker>

        <!-- chọn khối -->
        <el-select
            v-if="this.getAppTypeUserLogin === 'plus'"
            class="input-common input-grade"
            style="width: 140px"
            v-model="dataSearch.idGrade"
            @change="handleChangeGrade()"
            placeholder="Chọn khối"
        >
          <el-option
              v-for="item in gradeOfSchoolList"
              :key="item.id"
              :value="item.id"
              :label="item.gradeName"
          ></el-option>
        </el-select>

        <!-- chọn lớp -->
        <el-select
            class="input-common input-class"
            style="width: 140px"
            v-model="dataSearch.idClass"
            placeholder="Chọn lớp"
            @change="getSearchAllAttendanceDetail()"
        >
          <el-option
              v-for="item in classList"
              :key="item.id"
              :value="item.id"
              :label="item.className"
          ></el-option>
        </el-select>

        <!-- trạng thái điểm danh -->
        <el-select
            v-model="dataSearch.absentStatus"
            placeholder="Chọn trạng thái"
            clearable
            class="input-common input-status"
            style="width: 160px"
            @change="getSearchAllAttendanceDetail()"
        >
          <el-option
              v-for="item in statusGoToSchoolList"
              :key="item.value"
              :value="item.value"
              :label="item.label"
          ></el-option>
        </el-select>
      </div>

      <!-- search of attendance arrive -->
      <div v-else-if="visibleAttendanceArrive">
        <el-date-picker
            class="input-common input-date"
            style="width: 135px"
            :clearable="false"
            v-model="dataSearch.date"
            type="date"
            format="dd-MM-yyyy"
            value-format="yyyy-MM-dd"
            placeholder="Chọn ngày"
            :picker-options="startDayOfWeek"
            @change="checkAbsentDateInClass('arrive')"
        ></el-date-picker>

        <!-- chọn khối -->
        <el-select
            v-if="this.getAppTypeUserLogin === 'plus'"
            class="input-common input-grade"
            style="width: 140px"
            v-model="dataSearch.idGrade"
            @change="changeGradeArrive()"
            placeholder="Chọn khối"
        >
          <el-option
              v-for="item in gradeOfSchoolList"
              :key="item.id"
              :value="item.id"
              :label="item.gradeName"
          ></el-option>
        </el-select>

        <!-- chọn lớp -->
        <el-select
            class="input-common input-class"
            style="width: 140px"
            v-model="dataSearch.idClass"
            placeholder="Chọn lớp"
            @change="checkAbsentDateInClass('arrive')"
        >
          <el-option
              v-for="item in classList"
              :key="item.id"
              :value="item.id"
              :label="item.className"
          ></el-option>
        </el-select>

        <!-- tình trạng đi học -->
        <el-select
            v-model="dataSearch.absentStatus"
            placeholder="Chọn trạng thái"
            clearable
            class="input-common input-status"
            style="width: 160px"
            @change="checkAbsentDateInClass('arrive')"
        >
          <el-option
              v-for="item in statusGoToSchoolList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
          ></el-option>
        </el-select>
      </div>
    </div>

    <!-- tab -->
    <div class="content-main">
      <div>
        <el-tabs type="card" @tab-click="handleClickTab" v-model="activeTabName">
          <!-- tab detail -->
          <el-tab-pane label="Chi tiết ngày" name="detailDate">
            <el-table
                ref="multipleTable"
                :empty-text="textTable"
                v-loading="loadingData"
                :element-loading-text="$tableLoading"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255,255,255, 0)"
                :data="attendanceDetailDateList"
                :cell-style="tableRowStyleDetail"
                :header-cell-style="tableHeaderColor"
                :max-height="$tableMaxHeight"
                border
            >
              <el-table-column
                  type="selection"
                  width="55"
                  align="center"
              ></el-table-column>
              <el-table-column
                  fixed
                  type="index"
                  label="STT"
                  width="50"
                  align="center"
              ></el-table-column>
              <el-table-column
                  fixed
                  prop="kids.fullName"
                  label="Họ tên"
                  min-width="160"
              ></el-table-column>
              <el-table-column
                  prop="maClass.className"
                  label="Lớp"
                  min-width="130"
              ></el-table-column>
              <el-table-column
                  v-if="configSchoolCommon.morningAttendanceArrive"
                  label="Sáng"
                  align="center"
              >
                <el-table-column label="Đi học" align="center" width="90" header>
                  <template v-slot:default="scope">
                    <i
                        class="el-icon-circle-check"
                        v-if="scope.row.attendanceArriveKids.morning"
                        style="color: #409eff; font-size: 18px"
                    />
                  </template>
                </el-table-column>
                <el-table-column label="Có phép" align="center" width="90" header>
                  <template v-slot:default="scope">
                    <i
                        class="el-icon-circle-close"
                        style="color: #f56c6c; font-size: 18px"
                        v-if="scope.row.attendanceArriveKids.morningYes"
                    />
                  </template>
                </el-table-column>
                <el-table-column label="Không phép" align="center" width="95" header>
                  <template v-slot:default="scope">
                    <i
                        class="el-icon-error"
                        style="color: #f56c6c; font-size: 18px"
                        v-if="scope.row.attendanceArriveKids.morningNo"
                    />
                  </template>
                </el-table-column>
                <el-table-column label="Giờ đến" width="90" align="center">
                  <template v-slot:default="scope">
                  <span>{{
                      scope.row.attendanceArriveKids.timeArriveKidMorning | formatTime
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="Giờ về" width="90" align="center">
                  <template v-slot:default="scope">
                  <span>{{
                      scope.row.attendanceLeaveKids.timeLeaveKidMorning | formatTime
                    }}</span>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column
                  v-if="configSchoolCommon.afternoonAttendanceArrive"
                  label="Chiều"
                  align="center"
              >
                <el-table-column label="Đi học" align="center" width="90" header>
                  <template v-slot:default="scope">
                    <i
                        class="el-icon-circle-check"
                        v-if="scope.row.attendanceArriveKids.afternoon"
                        style="font-size: 18px; color: #409eff"
                    />
                  </template>
                </el-table-column>
                <el-table-column label="Có phép" align="center" width="90" header>
                  <template v-slot:default="scope">
                    <i
                        class="el-icon-circle-close"
                        style="color: #f56c6c; font-size: 18px"
                        v-if="scope.row.attendanceArriveKids.afternoonYes"
                    />
                  </template>
                </el-table-column>
                <el-table-column label="Không phép" align="center" width="95" header>
                  <template v-slot:default="scope">
                    <i
                        class="el-icon-error"
                        style="color: #f56c6c; font-size: 18px"
                        v-if="scope.row.attendanceArriveKids.afternoonNo"
                    />
                  </template>
                </el-table-column>
                <el-table-column label="Giờ đến" width="90" align="center">
                  <template v-slot:default="scope">
                  <span>{{
                      scope.row.attendanceArriveKids.timeArriveKidAfternoon | formatTime
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="Giờ về" width="90" align="center">
                  <template v-slot:default="scope">
                  <span>{{
                      scope.row.attendanceLeaveKids.timeLeaveKidAfternoon | formatTime
                    }}</span>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column
                  v-if="configSchoolCommon.eveningAttendanceArrive"
                  label="Tối"
                  align="center"
              >
                <el-table-column label="Đi học" align="center" width="90" header>
                  <template v-slot:default="scope">
                    <i
                        class="el-icon-circle-check"
                        style="font-size: 18px; color: #409eff"
                        v-if="scope.row.attendanceArriveKids.evening"
                    />
                  </template>
                </el-table-column>
                <el-table-column label="Có phép" align="center" width="90" header>
                  <template v-slot:default="scope">
                    <i
                        class="el-icon-circle-close"
                        style="color: #f56c6c; font-size: 18px"
                        v-if="scope.row.attendanceArriveKids.eveningYes"
                    />
                  </template>
                </el-table-column>
                <el-table-column label="Không phép" align="center" width="95" header>
                  <template v-slot:default="scope">
                    <i
                        class="el-icon-error"
                        style="color: #f56c6c; font-size: 18px"
                        v-if="scope.row.attendanceArriveKids.eveningNo"
                    />
                  </template>
                </el-table-column>
                <el-table-column label="Giờ đến" width="90" align="center">
                  <template v-slot:default="scope">
                  <span>{{
                      scope.row.attendanceArriveKids.timeArriveKidEvening | formatTime
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="Giờ về" width="90" align="center">
                  <template v-slot:default="scope">
                  <span>{{
                      scope.row.attendanceLeaveKids.timeLeaveKidEvening | formatTime
                    }}</span>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column label="Tác vụ" fixed="right" width="200" align="center">
                <template v-slot:default="scope">
                  <el-button
                      size="mini"
                      type="success"
                      @click="handleShowDetailDate(scope.$index, scope.row)"
                  >{{ $t("button.view") }}
                  </el-button
                  >
                  <el-button
                      size="mini"
                      type="primary"
                      @click="checkInformationAI(scope.$index, scope.row)"
                  >Kiểm tra AI
                  </el-button
                  >
                  <!-- <el-button v-else disabled size="mini" type="success">{{
                    $t("button.view")
                  }}</el-button> -->
                </template>
              </el-table-column>
            </el-table>
            <!-- click xuất file -->
            <div style="float: right; margin: 15px 0">
              <el-dropdown @command="handleCommand">
                <el-button type="success" class="button-bottom">
                  {{ $t("button.exportFile") }}
                  <i class="el-icon-caret-bottom"/>
                </el-button>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item command="exportDate">Xuất theo ngày</el-dropdown-item>
                    <el-dropdown-item command="exportMonth">
                      Xuất theo tháng
                    </el-dropdown-item>
                    <el-dropdown-item command="exportCustom">
                      Xuất file tổng hợp
                    </el-dropdown-item>
<!--                    <el-dropdown-item command="exportMonthDetail">-->
<!--                      Xuất file chi tiết tháng (A)-->
<!--                    </el-dropdown-item>-->

<!--                    <el-dropdown-item command="exportMonthDetailOld">-->
<!--                      Xuất file chi tiết tháng (B)-->
<!--                    </el-dropdown-item>-->
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
          </el-tab-pane>

          <!-- tab attendance arrive -->
          <el-tab-pane
              label="Điểm danh"
              name="attendanceArriveTab"
          >
            <el-table
                ref="multipleTable"
                :empty-text="textTable"
                v-loading="loadingData"
                :element-loading-text="$tableLoading"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255,255,255, 0)"
                :data="attendanceArriveList"
                :cell-style="tableRowStyleDetail"
                :header-cell-style="tableHeaderColor"
                @selection-change="handleSelectionChangeArrive"
                :max-height="$tableMaxHeight"
                border
            >
              <el-table-column
                  type="selection"
                  align="center"
                  width="55"
              ></el-table-column>
              <el-table-column
                  type="index"
                  label="STT"
                  align="center"
                  width="50"
                  fixed
              ></el-table-column>
              <el-table-column
                  prop="kids.fullName"
                  label="Họ tên"
                  min-width="160"
                  fixed
              ></el-table-column>
              <el-table-column
                  prop="maClass.className"
                  label="Lớp"
                  min-width="130"
              ></el-table-column>
              <!-- buổi sáng -->
              <el-table-column
                  v-if="configSchoolCommon.morningAttendanceArrive"
                  label="Sáng"
                  align="center"
              >
                <el-table-column align="center" width="100">
                  <template #header="scope">
                    <span class="second-title">Đi học</span>
                    <br/>
                    <el-checkbox
                        @change="changeAllMorning(scope.$index, 1)"
                        v-model="checkboxAllMorning1"
                    ></el-checkbox>
                  </template>
                  <template v-slot:default="scope">
                    <el-checkbox
                        @change="checkRowMorningDay(1, scope.row)"
                        v-model="scope.row.attendanceArriveKids.morning"
                    ></el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column align="center" width="100">
                  <template #header="scope">
                    <span class="second-title">Có phép</span>
                    <br/>
                    <el-checkbox
                        @change="changeAllMorning(scope.$index, 2)"
                        v-model="checkboxAllMorning2"
                    ></el-checkbox>
                  </template>
                  <template v-slot:default="scope">
                    <el-checkbox
                        @change="checkRowMorningDay(2, scope.row)"
                        v-model="scope.row.attendanceArriveKids.morningYes"
                    ></el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column align="center" width="100">
                  <template #header="scope">
                    <span class="second-title">Không phép</span>
                    <br/>
                    <el-checkbox
                        @change="changeAllMorning(scope.$index, 3)"
                        v-model="checkboxAllMorning3"
                    ></el-checkbox>
                  </template>
                  <template v-slot:default="scope">
                    <el-checkbox
                        @change="checkRowMorningDay(3, scope.row)"
                        v-model="scope.row.attendanceArriveKids.morningNo"
                    ></el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column
                    v-if="
                  configSchoolCommon.morningAttendanceArrive ||
                  configSchoolCommon.afternoonAttendanceArrive ||
                  configSchoolCommon.eveningAttendanceArrive
                "
                    align="center"
                    label="Giờ đến"
                    width="135"
                >
                  <template v-slot:default="scope">
                    <el-time-picker
                        type="time"
                        value-format="HH:mm"
                        format="HH:mm"
                        style="width: 85%"
                        size="mini"
                        v-if="!scope.row.attendanceArriveKids.morning "
                        disabled
                        v-model="scope.row.attendanceArriveKids.timeArriveKidMorning"
                        :picker-options="{
                      selectableRange: '00:00:00 - 23:59:59',
                    }"
                        placeholder="Chọn"
                    ></el-time-picker>
                    <el-time-picker
                        v-else
                        type="time"
                        value-format="HH:mm"
                        format="HH:mm"
                        style="width: 85%"
                        size="mini"
                        v-model="scope.row.attendanceArriveKids.timeArriveKidMorning"
                        :picker-options="{
                      selectableRange: '00:00:00 - 23:59:59',
                    }"
                        placeholder="Chọn"
                    ></el-time-picker>
                  </template>
                </el-table-column>
                <el-table-column
                    v-if="configSchoolCommon.morningAttendanceArrive"
                    align="center"
                    width="135"
                >
                  <template #header="scope">
                    <span class="second-title">Giờ về</span>
                    <br/>
                    <el-checkbox
                        @change="changeMorningAttendanceLeave(scope.$index)"
                        v-model="checkboxAllLeaveMorning"
                    ></el-checkbox>
                  </template>
                  <template v-slot:default="scope">
                    <el-time-picker
                        type="time"
                        value-format="HH:mm"
                        format="HH:mm"
                        style="width: 85%"
                        size="mini"
                        v-if=" !scope.row.attendanceArriveKids.morning"
                        disabled
                        v-model="scope.row.attendanceLeaveKids.timeLeaveKidMorning"
                        :picker-options="{
                      selectableRange: '00:00:00 - 23:59:59',
                    }"
                        placeholder="Chọn"
                    ></el-time-picker>
                    <el-time-picker
                        v-else
                        type="time"
                        value-format="HH:mm"
                        format="HH:mm"
                        style="width: 85%"
                        size="mini"
                        v-model="scope.row.attendanceLeaveKids.timeLeaveKidMorning"
                        :picker-options="{
                      selectableRange: '00:00:00 - 23:59:59',
                    }"
                        placeholder="Chọn"
                    ></el-time-picker>
                  </template>
                </el-table-column>
              </el-table-column>

              <el-table-column
                  v-if="configSchoolCommon.afternoonAttendanceArrive"
                  label="Chiều"
                  align="center"
              >
                <el-table-column align="center" width="100">
                  <template #header="scope">
                    <span class="second-title">Đi học</span>
                    <br/>
                    <el-checkbox
                        @change="changeAllAfternoon(scope.$index, 1)"
                        v-model="checkboxAllAfternoon1"
                    ></el-checkbox>
                  </template>
                  <template v-slot:default="scope">
                    <el-checkbox
                        @change="checkRowAfternoonDay(1, scope.row)"
                        v-model="scope.row.attendanceArriveKids.afternoon"
                    ></el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column align="center" width="100">
                  <template #header="scope">
                    <span class="second-title">Có phép</span>
                    <br/>
                    <el-checkbox
                        @change="changeAllAfternoon(scope.$index, 2)"
                        v-model="checkboxAllAfternoon2"
                    ></el-checkbox>
                  </template>
                  <template v-slot:default="scope">
                    <el-checkbox
                        @change="checkRowAfternoonDay(2, scope.row)"
                        v-model="scope.row.attendanceArriveKids.afternoonYes"
                    ></el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column align="center" width="100">
                  <template #header="scope">
                    <span class="second-title">Không phép</span>
                    <br/>
                    <el-checkbox
                        @change="changeAllAfternoon(scope.$index, 3)"
                        v-model="checkboxAllAfternoon3"
                    ></el-checkbox>
                  </template>
                  <template v-slot:default="scope">
                    <el-checkbox
                        @change="checkRowAfternoonDay(3, scope.row)"
                        v-model="scope.row.attendanceArriveKids.afternoonNo"
                    ></el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column
                    v-if="
                  configSchoolCommon.afternoonAttendanceArrive
                "
                    align="center"
                    label="Giờ đến"
                    width="135"
                >
                  <template v-slot:default="scope">
                    <el-time-picker
                        type="time"
                        value-format="HH:mm"
                        format="HH:mm"
                        style="width: 85%"
                        size="mini"
                        v-if="
                      !scope.row.attendanceArriveKids.afternoon
                    "
                        disabled
                        v-model="scope.row.attendanceArriveKids.timeArriveKidAfternoon"
                        :picker-options="{
                      selectableRange: '00:00:00 - 23:59:59',
                    }"
                        placeholder="Chọn"
                    ></el-time-picker>
                    <el-time-picker
                        v-else
                        type="time"
                        value-format="HH:mm"
                        format="HH:mm"
                        style="width: 85%"
                        size="mini"
                        v-model="scope.row.attendanceArriveKids.timeArriveKidAfternoon"
                        :picker-options="{
                      selectableRange: '00:00:00 - 23:59:59',
                    }"
                        placeholder="Chọn"
                    ></el-time-picker>
                  </template>
                </el-table-column>
                <el-table-column
                    v-if="
                  configSchoolCommon.afternoonAttendanceArrive
                "
                    align="center"
                    width="135"
                >
                  <template #header="scope">
                    <span class="second-title">Giờ về</span>
                    <br/>
                    <el-checkbox
                        @change="changeAfternoonAttendanceLeave(scope.$index)"
                        v-model="checkboxAllLeaveAfternoon"
                    ></el-checkbox>
                  </template>
                  <template v-slot:default="scope">
                    <el-time-picker
                        type="time"
                        value-format="HH:mm"
                        format="HH:mm"
                        style="width: 85%"
                        size="mini"
                        v-if="
                      !scope.row.attendanceArriveKids.afternoon
                    "
                        disabled
                        v-model="scope.row.attendanceLeaveKids.timeLeaveKidAfternoon"
                        :picker-options="{
                      selectableRange: '00:00:00 - 23:59:59',
                    }"
                        placeholder="Chọn"
                    ></el-time-picker>
                    <el-time-picker
                        v-else
                        type="time"
                        value-format="HH:mm"
                        format="HH:mm"
                        style="width: 85%"
                        size="mini"
                        v-model="scope.row.attendanceLeaveKids.timeLeaveKidAfternoon"
                        :picker-options="{
                      selectableRange: '00:00:00 - 23:59:59',
                    }"
                        placeholder="Chọn"
                    ></el-time-picker>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column
                  label="Tối"
                  v-if="configSchoolCommon.eveningAttendanceArrive"
                  align="center"
              >
                <el-table-column align="center" width="100">
                  <template #header="scope">
                    <span class="second-title">Đi học</span>
                    <br/>
                    <el-checkbox
                        @change="changeAllEvening(scope.$index, 1)"
                        v-model="checkboxAllEvening1"
                    ></el-checkbox>
                  </template>
                  <template v-slot:default="scope">
                    <el-checkbox
                        @change="checkRowEveningDay(1, scope.row)"
                        v-model="scope.row.attendanceArriveKids.evening"
                    ></el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column align="center" width="100">
                  <template #header="scope">
                    <span class="second-title">Có phép</span>
                    <br/>
                    <el-checkbox
                        @change="changeAllEvening(scope.$index, 2)"
                        v-model="checkboxAllEvening2"
                    ></el-checkbox>
                  </template>
                  <template v-slot:default="scope">
                    <el-checkbox
                        @change="checkRowEveningDay(2, scope.row)"
                        v-model="scope.row.attendanceArriveKids.eveningYes"
                    ></el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column align="center" width="100">
                  <template #header="scope">
                    <span class="second-title">Không phép</span>
                    <br/>
                    <el-checkbox
                        @change="changeAllEvening(scope.$index, 3)"
                        v-model="checkboxAllEvening3"
                    ></el-checkbox>
                  </template>
                  <template v-slot:default="scope">
                    <el-checkbox
                        @change="checkRowEveningDay(3, scope.row)"
                        v-model="scope.row.attendanceArriveKids.eveningNo"
                    ></el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column
                    v-if="
                  configSchoolCommon.eveningAttendanceArrive
                "
                    align="center"
                    label="Giờ đến"
                    width="135"
                >
                  <template v-slot:default="scope">
                    <el-time-picker
                        type="time"
                        value-format="HH:mm"
                        format="HH:mm"
                        style="width: 85%"
                        size="mini"
                        v-if="
                      !scope.row.attendanceArriveKids.evening
                    "
                        disabled
                        v-model="scope.row.attendanceArriveKids.timeArriveKidEvening"
                        :picker-options="{
                      selectableRange: '00:00:00 - 23:59:59',
                    }"
                        placeholder="Chọn"
                    ></el-time-picker>
                    <el-time-picker
                        v-else
                        type="time"
                        value-format="HH:mm"
                        format="HH:mm"
                        style="width: 85%"
                        size="mini"
                        v-model="scope.row.attendanceArriveKids.timeArriveKidEvening"
                        :picker-options="{
                      selectableRange: '00:00:00 - 23:59:59',
                    }"
                        placeholder="Chọn"
                    ></el-time-picker>
                  </template>
                </el-table-column>
                <el-table-column
                    v-if="
                  configSchoolCommon.eveningAttendanceArrive
                "
                    align="center"
                    width="135"
                >
                  <template #header="scope">
                    <span class="second-title">Giờ về</span>
                    <br/>
                    <el-checkbox
                        @change="changeEveningAttendanceLeave(scope.$index)"
                        v-model="checkboxAllLeaveEvening"
                    ></el-checkbox>
                  </template>
                  <template v-slot:default="scope">
                    <el-time-picker
                        type="time"
                        value-format="HH:mm"
                        format="HH:mm"
                        style="width: 85%"
                        size="mini"
                        v-if="
                      !scope.row.attendanceArriveKids.evening
                    "
                        disabled
                        v-model="scope.row.attendanceLeaveKids.timeLeaveKidEvening"
                        :picker-options="{
                      selectableRange: '00:00:00 - 23:59:59',
                    }"
                        placeholder="Chọn"
                    ></el-time-picker>
                    <el-time-picker
                        v-else
                        type="time"
                        value-format="HH:mm"
                        format="HH:mm"
                        style="width: 85%"
                        size="mini"
                        v-model="scope.row.attendanceLeaveKids.timeLeaveKidEvening"
                        :picker-options="{
                      selectableRange: '00:00:00 - 23:59:59',
                    }"
                        placeholder="Chọn"
                    ></el-time-picker>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column fixed="right" label="Tác vụ" width="150" align="center">
                <template v-slot:default="scope">
                  <span
                      v-if="
                      configSchoolCommon.morningAttendanceArrive ||
                      configSchoolCommon.afternoonAttendanceArrive ||
                      configSchoolCommon.eveningAttendanceArrive
                    "
                      style="margin-right: 10px"
                  >
                    <el-button
                        size="mini"
                        type="primary"
                        @click="handleArriveRowSave(scope.$index, scope.row)"
                    >{{ $t("button.save") }}</el-button
                    >
                    <el-button
                        size="mini"
                        type="success"
                        @click="handleArriveUpdateRowMethod(scope.$index, scope.row)"
                    >{{ $t("button.update") }}</el-button
                    >
                  </span>
                </template>
              </el-table-column>
            </el-table>
            <!-- click xuất file -->
            <div style="float: right; margin: 15px 0">
              <el-button
                  v-if="
                  configSchoolCommon.morningAttendanceArrive ||
                  configSchoolCommon.afternoonAttendanceArrive ||
                  configSchoolCommon.eveningAttendanceArrive
                "
                  type="success"
                  class="button-bottom"
                  :loading="loadingButtonSaveArriveDate"
                  @click="handleArriveManyRowSave()"
              >
                <i class="el-icon-circle-check"/>
                Lưu điểm danh
              </el-button>
              <el-dropdown @command="handleCommand">
                <el-button type="success" class="button-bottom">
                  {{ $t("button.exportFile") }}
                  <i class="el-icon-caret-bottom"/>
                </el-button>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item command="exportDate">Xuất theo ngày</el-dropdown-item>
                    <el-dropdown-item command="exportMonth"
                    >Xuất theo tháng
                    </el-dropdown-item
                    >
                    <el-dropdown-item command="exportCustom">
                      Xuất file tổng hợp
                    </el-dropdown-item>
<!--                    <el-dropdown-item command="exportMonthDetail">-->
<!--                      Xuất file chi tiết tháng (A)-->
<!--                    </el-dropdown-item>-->

<!--                    <el-dropdown-item command="exportMonthDetailOld">-->
<!--                      Xuất file chi tiết tháng (B)-->
<!--                    </el-dropdown-item>-->
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
          </el-tab-pane>

          <el-button
              style="float: right; margin: 15px 0"
              class="button-bottom"
              type="success"
              @click="viewCalendarClassMethod()"
          >Xem lịch học
          </el-button
          >
        </el-tabs>
      </div>
    </div>
    <AttendanceViewV2
        :dialogVisible="showDialogViewDetailDate"
        @dialog-close="closeDialogViewDetailDateMethod()"
        ref="AttendanceViewV2"
    />
    <AttendanceArriveUpdateV2
        :dialogVisible="showDialogUpdateArrive"
        @dialog-close="closeDialogUpdateArriveMethod()"
        ref="AttendanceArriveUpdateV2"
    />
    <AttendanceArriveOfMonth
        :dialogVisible="showDialogDetailArrive"
        @dialog-close="closeDialogDetailArriveMethod()"
        ref="AttendanceArriveOfMonth"
    />
    <AttendanceLeaveUpdate
        :dialogVisible="showDialogUpdateLeave"
        @dialog-close="closeDialogUpdateLeaveMethod()"
        ref="AttendanceLeaveUpdate"
    />
    <AttendanceLeaveOfMonth
        :dialogVisible="showDialogDetailLeave"
        @dialog-close="closeDialogDetailLeaveMethod()"
        ref="AttendanceLeaveOfMonth"
    />
    <AttendanceEatOfMonth
        :dialogVisible="showDialogDetailEat"
        @dialog-close="closeDialogDetailEatMethod()"
        ref="AttendanceEatOfMonth"
    />
    <CreateAttendanceKidCustomExcelV2
        :dialogVisible="showDialogCreateAttendanceKidCustomExcel"
        @dialog-close="closeDialogAttendanceKidCustomExcel()"
        ref="CreateAttendanceKidCustomExcel"
    />
    <CreateAttendanceKidDetailExcel
        :dialogVisible="showDialogCreateAttendanceKidMonthDetail"
        @dialog-close="closeDialogAttendanceKidMonthDetailExcel()"
        ref="CreateAttendanceKidDetailExcel"
    />

    <CreateAttendanceKidDetailExcelOld
        :dialogVisible="showDialogCreateAttendanceKidMonthDetailOld"
        @dialog-close="closeDialogAttendanceKidMonthDetailExcelOld()"
        ref="CreateAttendanceKidDetailExcelOld"
    />
    <DayOffClassDialog
        :dialogVisible="showDayOffClassDialog"
        @dialog-close="closeDayOffClassDialog()"
        ref="DayOffClassDialog"
    />
    <CheckInformationAIDialog
        :dialogVisible="isOpenCheckInformationAIDialog"
        @dialog-close="closeCheckInformationAIDialog()"
        ref="CheckInformationAIDialog"
    />
  </div>
</template>

<script>
import checkPermission from "@/utils/permission.js";
import moment from "moment";
import AttendanceService from "@/services/AttendanceService";
import AttendanceArriveOfMonth from "./AttendanceArriveOfMonth.vue";
import AttendanceLeaveUpdate from "./AttendanceLeaveUpdate.vue";
import AttendanceLeaveOfMonth from "./AttendanceLeaveOfMonth.vue";
import AttendanceEatOfMonth from "./AttendanceEatOfMonth.vue";
import DayOffClassDialog from "./DayOffClassDialog.vue";
import CreateAttendanceKidDetailExcel from "./CreateAttendanceKidDetailExcel.vue";
import {mapGetters, mapState} from "vuex";
import CreateAttendanceKidDetailExcelOld from "@/views/studentquality/CreateAttendanceKidDetailExcelOld.vue";
import AttendanceArriveUpdateV2 from "@/views/studentquality/AttendanceArriveUpdateV2.vue";
import AttendanceViewV2 from "@/views/studentquality/AttendanceViewV2.vue";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import CreateAttendanceKidCustomExcelV2 from "@/views/studentquality/CreateAttendanceKidCustomExcelV2.vue";
import CheckInformationAIDialog from "@/views/attendance-v2/dialog/CheckInformationAIDialog.vue";

export default {
  components: {
    CheckInformationAIDialog,
    CreateAttendanceKidCustomExcelV2,
    AttendanceViewV2,
    AttendanceArriveUpdateV2,
    CreateAttendanceKidDetailExcelOld,
    AttendanceArriveOfMonth,
    AttendanceLeaveUpdate,
    AttendanceLeaveOfMonth,
    AttendanceEatOfMonth,
    DayOffClassDialog,
    CreateAttendanceKidDetailExcel,
  },
  data() {
    return {
      dateStartEnd: "",
      loadingData: true,
      textTable: "",
      activeTabName: "detailDate",
      startDayOfWeek: {
        firstDayOfWeek: 1,
      },
      loadingButtonSaveArriveDate: false,
      loadingButtonSaveLeaveDate: false,
      loadingButtonSaveEatDate: false,
      visibleDetailDate: true,
      visibleAttendanceArrive: false,
      visibleAtendanceLeave: false,
      visibleAttendanceEat: false,
      multipleSelectionArrive: [],
      multipleSelectionLeave: [],
      multipleSelectionEat: [],
      showDialogUpdateArrive: false,
      showDialogUpdateLeave: false,
      showDialogViewDetailDate: false,
      showDialogDetailArrive: false,
      showDialogDetailLeave: false,
      showDialogDetailEat: false,
      showDialogCreateAttendanceKidCustomExcel: false,
      showDialogCreateAttendanceKidMonthDetail: false,
      showDialogCreateAttendanceKidMonthDetailOld: false,
      showDayOffClassDialog: false,
      attendanceArriveOneSave: {},
      attendanceLeaveOneSave: {},
      attendanceEatOneSave: {},
      attendanceArriveManySave: "",
      attendanceLeaveManySave: "",
      attendanceEatManySave: "",
      attendanceDetailDateList: [],
      attendanceArriveList: [],
      attendanceLeaveList: [],
      attendanceEatList: [],
      checkboxAllMorning: false,
      checkboxAllAfternoon: false,
      checkboxAllEvening: false,
      checkboxAllLeave: false,
      checkboxAllEatBreakfast: false,
      checkboxAllEatSecondBreakfast: false,
      checkboxAllEatLunch: false,
      checkboxAllEatAfternoon: false,
      checkboxAllEatSecondAfternoon: false,
      checkboxAllEatDinner: false,
      //start
      checkboxAllDay1: false,
      checkboxAllDay2: false,
      checkboxAllDay3: false,
      checkboxAllMorning1: false,
      checkboxAllMorning2: false,
      checkboxAllMorning3: false,
      checkboxAllAfternoon1: false,
      checkboxAllAfternoon2: false,
      checkboxAllAfternoon3: false,
      checkboxAllEvening1: false,
      checkboxAllEvening2: false,
      checkboxAllEvening3: false,

      checkboxAllLeaveMorning: false,
      checkboxAllLeaveAfternoon: false,
      checkboxAllLeaveEvening: false,
      isOpenCheckInformationAIDialog: false,

      //end
      fileList: [],
      configSchoolCommon: "",
      configSchoolCommonData: "",
      statusGoToSchoolList: [
        {value: true, label: "Đã điểm danh"},
        {value: false, label: "Chưa điểm danh"},
      ],
      dataSearch: {
        date: "",
        idGrade: "",
        idClass: "",
        absentStatus: "",
        attendanceStatus: "",
      },
      //css excel
      styleCols1: [],
      styleCols2: [],
    };
  },
  created() {
    this.$store.dispatch('gradeModule/fetchDataGradeOfSchoolList');
    if (this.getAppTypeUserLogin === "plus") {
      this.$store.dispatch('classStore/fetchDataClassListCommon');
    } else {
      this.$store.dispatch('classStore/fetchDataClassInTeacher');
    }
  },

  computed: {
    ...mapState('gradeModule', ['gradeOfSchoolList']),
    ...mapGetters('classStore', ['classInTeacher']),
    ...mapState('classStore', ['classListCommon']),
    classList() {
      if (this.getAppTypeUserLogin === "plus") {
        return this.classListCommon.filter((x) => x.idGrade === this.dataSearch.idGrade)
      } else if (this.getAppTypeUserLogin === "teacher") {
        return this.classInTeacher;
      } else return this.classListCommon
    },
    getAppTypeUserLogin() {
      return this.$store.state.auth.user.appType;
    },
  },

  watch: {
    gradeOfSchoolList: {
      immediate: true, // Kích hoạt ngay lập tức khi component được tạo
      handler(newVal) {
        if (newVal.length > 0) {
          this.getIdGrade();
        }
      },
    },
    classList: {
      handler(newVal) {
        if (newVal.length > 0) {
          this.getIdClass();
        }
      },
    },
  },
  methods: {
    checkPermission,
    checkInformationAI(index, row){
      let id = row.kids.id
      let name = row.kids.fullName
      this.isOpenCheckInformationAIDialog = true;
      this.$refs.CheckInformationAIDialog.getAddDataInitial(id,this.dataSearch.date,name)
    },
    closeCheckInformationAIDialog(){
      this.isOpenCheckInformationAIDialog = false;
    },
    handleChangeGrade() {
      if (this.getAppTypeUserLogin === "plus") {
        this.classList = this.classListCommon.filter((x) => x.idGrade === this.dataSearch.idGrade)
      } else if (this.getAppTypeUserLogin === "teacher") {
        this.classList = this.classInTeacher;
      } else {
        this.classList = this.classListCommon
      }
    },
    getIdGrade() {
      this.dataSearch.idGrade = this.gradeOfSchoolList[0].id;
    },
    getIdClass() {
      this.dataSearch.idClass = this.classList[0].id;
      this.getSearchAllAttendanceDetail()
    },
    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff;font-weight: bold;";
    },
    tableRowStyleDetail({row}) {
      //false->chưa điểm danh đến
      if (!row.attendanceArrive) {
        return "color: #409EFF";
        //true->nghỉ có phép hoặc không phép cả ngày theo config
      } else if (row.absentStatus) {
        return "color: red";
      }
    },
    tableRowStyleLeave({row}) {
      //false->chưa điểm danh về
      if (!row.attendanceLeave) {
        return "color: #409EFF";
      }
    },
    tableRowStyleEat({row}) {
      //false->chưa điểm danh ăn
      if (!row.attendanceEat) {
        return "color: #409EFF";
      }
    },
    handleCommand(command) {
      if (command === "exportDate") {
        this.exportExcelAttendanceDate();
      } else if (command === "exportMonth") {
        this.exportExcelAttendanceMonth();
      } else if (command === "exportCustom") {
        this.exportExcelAttendanceCustom();
      } else if (command === "exportMonthDetail") {
        this.exportExcelAttendanceMonthDetail();
      } else if (command === 'exportMonthDetailOld') {
        this.exportExcelAttendanceMonthDetailOld();
      }
    },
    handleClickTab(tab) {
      let tabNameClick = tab.name;
      if (tabNameClick === "detailDate") {
        this.visibleDetailDate = true;
        this.visibleAttendanceArrive = false;
        this.visibleAtendanceLeave = false;
        this.visibleAttendanceEat = false;
        this.getSearchAllAttendanceDetail();
      } else if (tabNameClick === "attendanceArriveTab") {
        this.visibleDetailDate = false;
        this.visibleAttendanceArrive = true;
        this.visibleAtendanceLeave = false;
        this.visibleAttendanceEat = false;
        this.checkboxAllMorning = false;
        this.checkboxAllAfternoon = false;
        this.checkboxAllEvening = false;
        this.checkAbsentDateInClass("arrive");
      }
    },
    exportExcelAttendanceDate() {
      let id;
      let date;
      if (this.dataSearch.idClass !== "" && this.dataSearch.date !== "") {
        id = this.dataSearch.idClass;
        date = this.dataSearch.date;
      } else if (this.dataSearch.idClass !== "" && this.dataSearch.date !== "") {
        id = this.dataSearch.idClass;
        date = this.dataSearch.date;
      } else if (this.dataSearch.idClass !== "" && this.dataSearch.date !== "") {
        id = this.dataSearch.idClass;
        date = this.dataSearch.date;
      } else if (this.dataSearch.idClass !== "" && this.dataSearch.date !== "") {
        id = this.dataSearch.idClass;
        date = this.dataSearch.date;
      }
      if (id === "" || id === undefined) {
        this.$message({
          message: "Bạn chưa chọn lớp",
          type: "error",
        });
        return;
      }
      this.$confirm("Bạn có chắc chắn muốn xuất file không?", "Thông báo!", {
        distinguishCancelAndClose: true,
        closeOnClickModal: false,
        confirmButtonText: "Có",
        cancelButtonText: "Không",
      }).then(() => {
        this.getStyleExcelDate();
        let myDate = moment().format("DD-MM-YYYY hh:mm:ss");
        AttendanceService.getExportExcelDateV2(id, date)
            .then((resp) => {
              import("@/services/ExportExcel")
                  .then((excel) => {
                    let dataList = resp.data.data;
                    let fileName = `QUAN_LY_DIEM_DANH_HOC_SINH_${myDate}`;
                    const merges = [
                      "A5:B5",
                      "C5:Q5",
                      "C6:G6",
                      "H6:L6",
                      "M6:Q6",
                      "A6:A7",
                      "B6:B7",
                      "R5:R7",
                    ];
                    const tHeader = [
                      "",
                      "",
                      "Có phép",
                      "Không phép",
                      "Đi học",
                      "Giờ đến",
                      "Giờ về",
                      "Có phép",
                      "Không phép",
                      "Đi học",
                      "Giờ đến",
                      "Giờ về",
                      "Có phép",
                      "Không phép",
                      "Đi học",
                      "Giờ đến",
                      "Giờ về",
                      "",
                    ];
                    const filterVal = [
                      "pro1",
                      "pro2",
                      "pro3",
                      "pro4",
                      "pro5",
                      "pro6",
                      "pro7",
                      "pro8",
                      "pro9",
                      "pro10",
                      "pro11",
                      "pro12",
                      "pro13",
                      "pro14",
                      "pro15",
                      "pro16",
                      "pro17",
                      "pro18",
                    ];
                    let columnList = [
                      {col: 5},
                      {col: 25},
                      {col: 10},
                      {col: 10},
                      {col: 10},
                      {col: 10},
                      {col: 10},
                      {col: 10},
                      {col: 10},
                      {col: 10},
                      {col: 10},
                      {col: 10},
                      {col: 10},
                      {col: 10},
                      {col: 10},
                      {col: 10},
                      {col: 10},
                      {col: 50},
                    ];
                    excel.export_json_to_excel({
                      header: tHeader,
                      merges,
                      data: dataList,
                      title: filterVal,
                      filename: fileName,
                      columnsWidth: columnList,
                      styleCols1: this.styleCols1,
                      styleCols2: this.styleCols2,
                    });
                  })
                  .finally(() => {
                    this.styleCols1 = [];
                    this.styleCols2 = [];
                  });
            })
            .catch((err) => {
              console.log(err);
              this.$message({
                message: "Thất bại",
                type: "error",
              });
            });
      });
    },
    //Style css Excel Date
    getStyleExcelDate() {
      let font = this.$styleExcel.fontTitle();
      let alignment = this.$styleExcel.alignmentTitle();
      let border = this.$styleExcel.borderTitle();
      let style1 = {
        name: "A6:Q7",
        style: {
          fill: {fgColor: {rgb: "f8eb00"}},
          font: font,
          alignment,
          border,
        },
      };
      let style2 = {
        name: "F4:Q4",
        style: {
          border: {bottom: {style: "thin"}},
        },
      };
      //style1
      let styleCol1 = {
        name: "A5:B5",
        style: {
          fill: {fgColor: {rgb: "cfcfcf"}},
          font: {bold: true, sz: "11", color: {rgb: "f70000"}},
          alignment,
          border,
        },
      };
      let styleCol2 = {
        name: "C5:Q100",
        style: {
          fill: {fgColor: {rgb: "95cb4a"}},
          font,
          alignment,
          border,
        },
      };
      // Style cho cột Ghi chú: tách header và phần dữ liệu
      let styleCol3Header = {
        name: "R5:R7",
        style: {
          fill: { patternType: "solid", fgColor: {rgb: "FFD966"}, bgColor: {rgb: "FFD966"} },
          font,
          // Tiêu đề căn giữa
          alignment,
          border,
        },
      };

      let styleCol3Data = {
        name: "R8:R100",
        style: {
          fill: { patternType: "solid", fgColor: {rgb: "FFD966"}, bgColor: {rgb: "FFD966"} },
          font,
          // Nội dung các dòng căn trái
          alignment: { horizontal: "left", vertical: "center", wrapText: true },
          border,
        },
      };

      let styleCol01 = {
        name: ["A1"],
        style: {
          font: {color: {rgb: "ff0000"}, bold: true, sz: "18"},
        },
      };
      let styleCol02 = {
        name: ["A2", "A3", "A4"],
        style: {
          font: {bold: true, sz: "11"},
        },
      };

      this.styleCols2.push(styleCol1);
      this.styleCols2.push(styleCol2);
      // Đẩy cả style cho header và phần data của cột Ghi chú
      this.styleCols2.push(styleCol3Header);
      this.styleCols2.push(styleCol3Data);
      this.styleCols2.push(style1);
      this.styleCols2.push(style2);
      this.styleCols1.push(styleCol01);
      this.styleCols1.push(styleCol02);
    },

    exportExcelAttendanceMonth() {
      let id;
      let date;
      if (this.dataSearch.idClass !== "" && this.dataSearch.date !== "") {
        id = this.dataSearch.idClass;
        date = this.dataSearch.date;
      } else if (this.dataSearch.idClass !== "" && this.dataSearch.date !== "") {
        id = this.dataSearch.idClass;
        date = this.dataSearch.date;
      } else if (this.dataSearch.idClass !== "" && this.dataSearch.date !== "") {
        id = this.dataSearch.idClass;
        date = this.dataSearch.date;
      } else if (this.dataSearch.idClass !== "" && this.dataSearch.date !== "") {
        id = this.dataSearch.idClass;
        date = this.dataSearch.date;
      }
      if (id === "" || id === undefined) {
        this.$message({
          message: "Bạn chưa chọn lớp",
          type: "error",
        });
        return;
      }
      this.$confirm("Bạn có chắc chắn muốn xuất file không?", "Thông báo!", {
        distinguishCancelAndClose: true,
        closeOnClickModal: false,
        confirmButtonText: "Có",
        cancelButtonText: "Không",
      }).then(() => {
        this.getStyleExcelDate();
        let myDate = moment().format("DD-MM-YYYY hh:mm:ss");
        AttendanceService.getExportExcelMonthV2(id, date)
            .then((resp) => {
              import("@/services/ExportExcel")
                  .then((excel) => {
                    let dataList = resp.data.data;
                    let fileName = `QUAN_LY_DIEM_DANH_HOC_SINH_THEO_THANG_${myDate}`;
                    const merges = [
                      "A5:B5",
                      "C5:Q5",
                      "C6:G6",
                      "H6:L6",
                      "M6:Q6",
                      "A6:A7",
                      "B6:B7",
                      "R5:R7",
                    ];
                    const tHeader = [
                      "",
                      "",
                      "Có phép",
                      "Không phép",
                      "Đi học",
                      "Giờ đến",
                      "Giờ về",
                      "Có phép",
                      "Không phép",
                      "Đi học",
                      "Giờ đến",
                      "Giờ về",
                      "Có phép",
                      "Không phép",
                      "Đi học",
                      "Giờ đến",
                      "Giờ về",
                      ""
                    ];
                    const filterVal = [
                      "pro1",
                      "pro2",
                      "pro3",
                      "pro4",
                      "pro5",
                      "pro6",
                      "pro7",
                      "pro8",
                      "pro9",
                      "pro10",
                      "pro11",
                      "pro12",
                      "pro13",
                      "pro14",
                      "pro15",
                      "pro16",
                      "pro17",
                      "pro18",
                    ];
                    let columnList = [
                      {col: 5},
                      {col: 25},
                      {col: 10},
                      {col: 10},
                      {col: 10},
                      {col: 10},
                      {col: 10},
                      {col: 10},
                      {col: 10},
                      {col: 10},
                      {col: 10},
                      {col: 10},
                      {col: 10},
                      {col: 10},
                      {col: 10},
                      {col: 10},
                      {col: 10},
                      {col: 50},
                    ];
                    excel.export_json_to_excel({
                      header: tHeader,
                      merges,
                      data: dataList,
                      title: filterVal,
                      filename: fileName,
                      columnsWidth: columnList,
                      styleCols1: this.styleCols1,
                      styleCols2: this.styleCols2,
                    });
                  })
                  .finally(() => {
                    this.styleCols1 = [];
                    this.styleCols2 = [];
                  });
            })
            .catch((err) => {
              console.log(err);
              this.$message({
                message: "Thất bại",
                type: "error",
              });
            });
      });
    },

    // export attendance custom
    exportExcelAttendanceCustom() {
      this.showDialogCreateAttendanceKidCustomExcel = true;
    },
    exportExcelAttendanceMonthDetail() {
      this.showDialogCreateAttendanceKidMonthDetail = true;
    },

    exportExcelAttendanceMonthDetailOld() {
      this.showDialogCreateAttendanceKidMonthDetailOld = true;
    },

    viewCalendarClassMethod() {
      this.showDayOffClassDialog = true;
      this.$refs.DayOffClassDialog.getCalendarInitial(this.dataSearch.idClass);
    },
    closeDialogDetailArriveMethod() {
      this.showDialogDetailArrive = false;
      this.getSearchAllAttendanceDetail();
    },
    closeDialogDetailLeaveMethod() {
      this.showDialogDetailLeave = false;
      this.getSearchAllAttendanceDetail();
    },
    closeDialogDetailEatMethod() {
      this.showDialogDetailEat = false;
      this.getSearchAllAttendanceDetail();
    },
    closeDayOffClassDialog() {
      this.showDayOffClassDialog = false;
      this.getSearchAllAttendanceDetail()
    },
    closeDialogAttendanceKidCustomExcel() {
      this.showDialogCreateAttendanceKidCustomExcel = false;
      this.getSearchAllAttendanceEat();
    },
    closeDialogAttendanceKidMonthDetailExcel() {
      this.showDialogCreateAttendanceKidMonthDetail = false;
      this.getSearchAllAttendanceDetail()
    },

    closeDialogAttendanceKidMonthDetailExcelOld() {
      this.showDialogCreateAttendanceKidMonthDetailOld = false;
      this.getSearchAllAttendanceDetail()
    },

    handleShowDetailDate(index, row) {
      this.$refs.AttendanceViewV2.getDataArriveRowInitial(row, this.configSchoolCommon);
      this.showDialogViewDetailDate = true;
    },
    closeDialogViewDetailDateMethod() {
      this.showDialogViewDetailDate = false;
      this.getSearchAllAttendanceDetail()
    },

    handleArriveUpdateRowMethod(index, row) {
      this.$refs.AttendanceArriveUpdateV2.getDataArriveRowInitial(row, this.configSchoolCommon);
      this.showDialogUpdateArrive = true;
    },
    closeDialogUpdateArriveMethod() {
      this.showDialogUpdateArrive = false;
      this.getSearchAllAttendanceDetail();
    },
    handleSelectionChangeArrive(val) {
      this.multipleSelectionArrive = val;
    },
    handleSelectionChangeLeave(val) {
      this.multipleSelectionLeave = val;
    },
    handleSelectionChangeEat(val) {
      this.multipleSelectionEat = val;
    },
    handleLeaveUpdateRowMethod(index, row) {
      this.$refs.AttendanceLeaveUpdate.getDataLeaveRowInitial(row);
      this.showDialogUpdateLeave = true;
    },
    closeDialogUpdateLeaveMethod() {
      this.showDialogUpdateLeave = false;
      this.getSearchAllAttendanceDetail();
    },
    /*file */

    /**handleUploadChange */
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },

    /**
     * lưu một row cho điểm danh đến
     */
    handleArriveRowSave(index, row) {
      row.attendanceArriveKids.afternoon ||
      row.attendanceArriveKids.evening
      // if (row.attendanceArriveKids.morning) {
      //   if (row.attendanceArriveKids.timeArriveKidMorning === null) {
      //     this.$message({
      //       message: "Chưa chọn giờ đến buổi sáng",
      //       type: "error",
      //     });
      //     return;
      //   }
      // }
      // if (row.attendanceArriveKids.afternoon) {
      //   if (row.attendanceArriveKids.timeArriveKidAfternoon === null) {
      //     this.$message({
      //       message: "Chưa chọn giờ đến buổi chiều",
      //       type: "error",
      //     });
      //     return;
      //   }
      // }
      // if (row.attendanceArriveKids.evening) {
      //   if (row.attendanceArriveKids.timeArriveKidEvening === null) {
      //     this.$message({
      //       message: "Chưa chọn giờ đến buổi tối",
      //       type: "error",
      //     });
      //     return;
      //   }
      // }
      let data = {
        className: row.maClass.className,
        fullName: row.kids.fullName,
        id: row.id,
        idCreated: row.attendanceArriveKids.idCreated,
        createdBy: row.attendanceArriveKids.createdBy,
        createdDate: row.attendanceArriveKids.createdDate,
        idModified: row.attendanceArriveKids.idModified,
        lastModifieBy: row.attendanceArriveKids.lastModifieBy,
        lastModifieDate: row.attendanceArriveKids.lastModifieDate,
        allDay: row.attendanceArriveKids.allDay,
        allDayYes: row.attendanceArriveKids.allDayYes,
        allDayNo: row.attendanceArriveKids.allDayNo,
        morning: row.attendanceArriveKids.morning,
        morningYes: row.attendanceArriveKids.morningYes,
        morningNo: row.attendanceArriveKids.morningNo,
        afternoon: row.attendanceArriveKids.afternoon,
        afternoonYes: row.attendanceArriveKids.afternoonYes,
        afternoonNo: row.attendanceArriveKids.afternoonNo,
        evening: row.attendanceArriveKids.evening,
        eveningYes: row.attendanceArriveKids.eveningYes,
        eveningNo: row.attendanceArriveKids.eveningNo,
        timeArriveKid: row.attendanceArriveKids.timeArriveKid,
        timeArriveKidMorning: row.attendanceArriveKids.timeArriveKidMorning,
        timeArriveKidAfternoon: row.attendanceArriveKids.timeArriveKidAfternoon,
        timeArriveKidEvening: row.attendanceArriveKids.timeArriveKidEvening,
        timeLeaveKidMorning: row.attendanceLeaveKids.timeLeaveKidMorning,
        timeLeaveKidAfternoon: row.attendanceLeaveKids.timeLeaveKidAfternoon,
        timeLeaveKidEvening: row.attendanceLeaveKids.timeLeaveKidEvening,
        leaveContent: row.attendanceLeaveKids.leaveContent,
        leaveUrlPicture: row.attendanceLeaveKids.leaveUrlPicture,
        timeLeaveKid: row.attendanceLeaveKids.timeLeaveKid,
        minutePickupLate: row.attendanceLeaveKids.minutePickupLate,
      }
      AttendanceService.saveArriveOneV2(row.id, data)
          .then((resp) => {
            this.attendanceArriveOneSave = resp.data.data;
            this.$message({
              message: "Lưu điểm danh đến thành công",
              type: "success",
            });
            this.getSearchAllAttendanceDetail();
          })
          .catch((err) => {
            console.log(err);
            this.$message({
              message: err.response.data.message,
              type: "error",
            });
          });
    },
    /**
     * lưu nhiều row cho điểm danh đến
     */
    handleArriveManyRowSave() {
      let kidList = this.multipleSelectionArrive;
      if (kidList.length === 0) {
        this.$message({
          message: "Không có học sinh nào được chọn",
          type: "error",
        });
        return;
      }
      let requests = []
      kidList.forEach((x) => {
        let data = {
          className: x.maClass.className,
          fullName: x.kids.fullName,
          id: x.id,
          idCreated: x.attendanceArriveKids.idCreated,
          createdBy: x.attendanceArriveKids.createdBy,
          createdDate: x.attendanceArriveKids.createdDate,
          idModified: x.attendanceArriveKids.idModified,
          lastModifieBy: x.attendanceArriveKids.lastModifieBy,
          lastModifieDate: x.attendanceArriveKids.lastModifieDate,
          allDay: x.attendanceArriveKids.allDay,
          allDayYes: x.attendanceArriveKids.allDayYes,
          allDayNo: x.attendanceArriveKids.allDayNo,
          morning: x.attendanceArriveKids.morning,
          morningYes: x.attendanceArriveKids.morningYes,
          morningNo: x.attendanceArriveKids.morningNo,
          afternoon: x.attendanceArriveKids.afternoon,
          afternoonYes: x.attendanceArriveKids.afternoonYes,
          afternoonNo: x.attendanceArriveKids.afternoonNo,
          evening: x.attendanceArriveKids.evening,
          eveningYes: x.attendanceArriveKids.eveningYes,
          eveningNo: x.attendanceArriveKids.eveningNo,
          timeArriveKid: x.attendanceArriveKids.timeArriveKid,
          timeArriveKidMorning: x.attendanceArriveKids.timeArriveKidMorning,
          timeArriveKidAfternoon: x.attendanceArriveKids.timeArriveKidAfternoon,
          timeArriveKidEvening: x.attendanceArriveKids.timeArriveKidEvening,
          timeLeaveKidMorning: x.attendanceLeaveKids.timeLeaveKidMorning,
          timeLeaveKidAfternoon: x.attendanceLeaveKids.timeLeaveKidAfternoon,
          timeLeaveKidEvening: x.attendanceLeaveKids.timeLeaveKidEvening,
          leaveContent: x.attendanceLeaveKids.leaveContent,
          leaveUrlPicture: x.attendanceLeaveKids.leaveUrlPicture,
          timeLeaveKid: x.attendanceLeaveKids.timeLeaveKid,
          minutePickupLate: x.attendanceLeaveKids.minutePickupLate,
        }
        requests.push(data)
      });
      this.loadingButtonSaveArriveDate = true;
      this.$confirm(
          "Bạn có chắc chắn muốn lưu điểm danh cho " +
          kidList.length +
          " học sinh đã chọn?",
          "Lưu điểm danh",
          {
            distinguishCancelAndClose: true,
            closeOnClickModal: false,
            confirmButtonText: "Có",
            cancelButtonText: "Không",
          }
      )
          .then(() => {
            AttendanceService.saveArriveManyV2(requests)
                .then((resp) => {
                  this.attendanceArriveManySave = resp.data.data;
                  NotifyMessage.leftCornerNotificationSuccess("Lưu điểm danh cho nhiều học sinh thành công")
                  this.getSearchAllAttendanceDetail();
                })
                .catch((err) => {
                  console.log(err);
                  this.$message({
                    message: err.response.data.message,
                    type: "error",
                  });
                });
          })
          .finally(() => {
            setTimeout(() => {
              this.loadingButtonSaveArriveDate = false;
            }, 500);
          });
    },

    /**
     * kiểm tra lớp đó trong ngày đó có đơn xin phép ngày chưa xác nhận hay không
     */
    checkAbsentDateInClass(type) {
      AttendanceService.checkAbsentDate(this.dataSearch.date, this.dataSearch.idClass)
          .then((resp) => {
            const data = resp.data.data;
            let absentList = data.dataList;

            const applicationForLeave = data.applicationForLeave;
            if (applicationForLeave) {
              if (absentList.length > 0) {
                this.$message({
                  message: "Bạn có " + absentList.length + " đơn xin nghỉ chưa được xác nhận",
                  type: "warning",
                  duration: 2500,
                });
              }
              this.getSearchAllAttendanceDetail()

            } else {
              if (absentList.length > 0) {
                if (type === "arrive") {
                  this.attendanceArriveList = [];
                } else if (type === "leave") {
                  this.attendanceLeaveList = [];
                }
                this.$alert(
                    "Bạn có " +
                    absentList.length +
                    " đơn xin nghỉ chưa được xác nhận, vui lòng xác nhận trước khi điểm danh",
                    "Thông báo!",
                    {
                      confirmButtonText: "Đã hiểu",
                    }
                );

              } else {
                this.getSearchAllAttendanceDetail()
              }
            }
          })
          .catch((err) => {
            this.attendanceArriveList = [];
            this.$message({
              message: err.response.data.message,
              type: "error",
            });
          });
    },

    /**
     * lấy danh sách tab chi tiết
     */
    async getSearchAllAttendanceDetail() {
      this.loadingData = true;
      this.textTable = "";
      await AttendanceService.searchAllService(
          this.dataSearch.date,
          this.dataSearch.idClass,
          this.dataSearch.absentStatus,
          this.dataSearch.attendanceStatus
      )
          .then((resp) => {
            this.attendanceDetailDateList = resp.data.data.attendanceDetailDateList;
            this.attendanceArriveList = resp.data.data.attendanceDetailDateList;
            this.configSchoolCommon = resp.data.data.attendanceConfigResponse;
            let dataList = (this.attendanceArriveList = resp.data.data.attendanceDetailDateList);
            if (dataList.length > 0) {
              this.setCheckboxHeaderMorning();
              this.setCheckboxHeaderAfternoon();
              this.setCheckboxHeaderEvening();
            }
          })
          .catch((err) => {
            this.$message({
              message: err.response.data.message,
              type: "error",
            });
            this.attendanceDetailDateList = [];
            this.textTable = this.$tableEmpty;
          })
          .finally(() => {
            this.loadingData = false;
            if (this.attendanceDetailDateList.length === 0) {
              this.textTable = this.$tableEmpty;
            }
          });
    },

    /**
     * tìm kiếm điểm danh đến cho các học sinh trong ngày
     */
    getSearchAllAttendanceArrive() {
      this.loadingData = true;
      this.textTable = "";
      AttendanceService.searchArriveDate(
          this.dataSearch.date,
          this.dataSearch.idClass,
          this.dataSearch.absentStatus
      )
          .then((resp) => {
            let dataList = (this.attendanceArriveList = resp.data.data.attendanceDateList);
            this.configSchoolCommon = resp.data.data.attendanceConfigResponse;
            if (dataList.length > 0) {
              this.setCheckboxHeaderMorning();
              this.setCheckboxHeaderAfternoon();
              this.setCheckboxHeaderEvening();
            }
          })
          .catch((err) => {
            this.$message({
              message: err.response.data.message,
              type: "error",
            });
            this.attendanceArriveList = [];
          })
          .finally(() => {
            if (this.attendanceArriveList.length === 0) {
              this.textTable = this.$tableEmpty;
            }
            this.loadingData = false;
          });
    },
    /**
     * tìm kiếm điểm danh về cho các học sinh trong ngày
     */
    getSearchAllAttendanceLeave() {
      this.loadingData = true;
      this.textTable = "";
      AttendanceService.searchLeaveDate(
          this.dataSearch.date,
          this.dataSearch.idClass,
          this.dataSearch.absentStatus
      )
          .then((resp) => {
            this.attendanceLeaveList = resp.data.data;
          })
          .catch((err) => {
            this.$message({
              message: err.response.data.message,
              type: "error",
            });
            this.attendanceLeaveList = [];
          })
          .finally(() => {
            if (this.attendanceLeaveList.length === 0) {
              this.textTable = this.$tableEmpty;
            }
            this.loadingData = false;
          });
    },
    /**
     * chọn checkbox mỗi hàng ở cả ngày
     */
    checkRowAllDay(type, row) {
      let configMoring = this.configSchoolCommon.morningAttendanceArrive;
      let configAfternoon = this.configSchoolCommon.afternoonAttendanceArrive;
      let configEvening = this.configSchoolCommon.eveningAttendanceArrive;
      let checkboxAllDay = row.attendanceArriveKids.allDay;
      let checkboxAllDayYes = row.attendanceArriveKids.allDayYes;
      let checkboxAllDayNo = row.attendanceArriveKids.allDayNo;
      if (type === 1) {
        if (configMoring) {
          row.attendanceArriveKids.morning = checkboxAllDay;
          this.checkRowMorningDay(type, row);
        }
        if (configAfternoon) {
          row.attendanceArriveKids.afternoon = checkboxAllDay;
          this.checkRowAfternoonDay(type, row);
        }
        if (configEvening) {
          row.attendanceArriveKids.evening = checkboxAllDay;
          this.checkRowEveningDay(type, row);
        }
      }
      if (type === 2) {
        if (configMoring) {
          row.attendanceArriveKids.morningYes = checkboxAllDayYes;
          this.checkRowMorningDay(type, row);
        }
        if (configAfternoon) {
          row.attendanceArriveKids.afternoonYes = checkboxAllDayYes;
          this.checkRowAfternoonDay(type, row);
        }
        if (configEvening) {
          row.attendanceArriveKids.eveningYes = checkboxAllDayYes;
          this.checkRowEveningDay(type, row);
        }
      }
      if (type === 3) {
        if (configMoring) {
          row.attendanceArriveKids.morningNo = checkboxAllDayNo;
          this.checkRowMorningDay(type, row);
        }
        if (configAfternoon) {
          row.attendanceArriveKids.afternoonNo = checkboxAllDayNo;
          this.checkRowAfternoonDay(type, row);
        }
        if (configEvening) {
          row.attendanceArriveKids.eveningNo = checkboxAllDayNo;
          this.checkRowEveningDay(type, row);
        }
      }
      this.setAllCheckboxAllDay();
    },

    /**
     * check all sáng
     */
    changeAllMorning(index, type) {
      let dataList = this.attendanceArriveList;
      let checkAll1 = this.checkboxAllMorning1;
      let checkAll2 = this.checkboxAllMorning2;
      let checkAll3 = this.checkboxAllMorning3;
      dataList.forEach((x) => {
        if (type === 1) {
          //đi học
          x.attendanceArriveKids.morning = checkAll1;
          if (checkAll1) {
            x.attendanceArriveKids.morningYes = false;
            x.attendanceArriveKids.morningNo = false;
          }
        } else if (type === 2) {
          //nghỉ có phép
          x.attendanceArriveKids.morningYes = checkAll2;
          if (checkAll2) {
            x.attendanceArriveKids.morning = false;
            x.attendanceArriveKids.morningNo = false;
          }
        } else if (type === 3) {
          //nghỉ không phép
          x.attendanceArriveKids.morningNo = checkAll3;
          if (checkAll3) {
            x.attendanceArriveKids.morning = false;
            x.attendanceArriveKids.morningYes = false;
          }
        }
        this.setTimeArriveMorningDataMethod(x.attendanceArriveKids);
      });
      this.setUniquesHeaderMornig(type);
    },

    /**
     * check tất cả các row buổi chiều
     */
    changeAllAfternoon(index, type) {
      let dataList = this.attendanceArriveList;
      let checkAll1 = this.checkboxAllAfternoon1;
      let checkAll2 = this.checkboxAllAfternoon2;
      let checkAll3 = this.checkboxAllAfternoon3;
      //đi học
      dataList.forEach((x) => {
        if (type === 1) {
          x.attendanceArriveKids.afternoon = checkAll1;
          if (checkAll1) {
            x.attendanceArriveKids.afternoonYes = false;
            x.attendanceArriveKids.afternoonNo = false;
          }
        } else if (type === 2) {
          //nghỉ có phép
          x.attendanceArriveKids.afternoonYes = checkAll2;
          if (checkAll2) {
            x.attendanceArriveKids.afternoon = false;
            x.attendanceArriveKids.afternoonNo = false;
          }
        } else if (type === 3) {
          //nghỉ không phép
          x.attendanceArriveKids.afternoonNo = checkAll3;
          if (checkAll3) {
            x.attendanceArriveKids.afternoon = false;
            x.attendanceArriveKids.afternoonYes = false;
          }
        }
        this.setTimeArriveAfternoonDataMethod(x.attendanceArriveKids);
      });
      this.setUniquesHeaderAfternoon(type);
    },
    /**
     * check tất cả các row buổi tối
     */
    changeAllEvening(index, type) {
      let dataList = this.attendanceArriveList;
      let checkAll1 = this.checkboxAllEvening1;
      let checkAll2 = this.checkboxAllEvening2;
      let checkAll3 = this.checkboxAllEvening3;
      //đi học
      dataList.forEach((x) => {
        if (type === 1) {
          x.attendanceArriveKids.evening = checkAll1;
          if (checkAll1) {
            x.attendanceArriveKids.eveningYes = false;
            x.attendanceArriveKids.eveningNo = false;
          }
        } else if (type === 2) {
          //nghỉ có phép
          x.attendanceArriveKids.eveningYes = checkAll2;
          if (checkAll2) {
            x.attendanceArriveKids.evening = false;
            x.attendanceArriveKids.eveningNo = false;
          }
        } else if (type === 3) {
          //nghỉ không phép
          x.attendanceArriveKids.eveningNo = checkAll3;
          if (checkAll3) {
            x.attendanceArriveKids.evening = false;
            x.attendanceArriveKids.eveningYes = false;
          }
        }
        this.setTimeArriveEveningDataMethod(x.attendanceArriveKids);
      });
      this.setUniquesHeaderEvening(type);
    },
    /**
     * set unique checkBox header cho các buổi
     */
    setUniquesHeaderMornig(type) {
      let checkAll1 = this.checkboxAllMorning1;
      let checkAll2 = this.checkboxAllMorning2;
      let checkAll3 = this.checkboxAllMorning3;
      if (type === 1) {
        if (checkAll1) {
          this.checkboxAllMorning2 = false;
          this.checkboxAllMorning3 = false;
        }
      } else if (type === 2) {
        if (checkAll2) {
          this.checkboxAllMorning1 = false;
          this.checkboxAllMorning3 = false;
        }
      } else if (type === 3) {
        if (checkAll3) {
          this.checkboxAllMorning1 = false;
          this.checkboxAllMorning2 = false;
        }
      }
    },
    /**
     * set unique checkBox header cho các buổi
     */
    setUniquesHeaderAfternoon(type) {
      let checkAll1 = this.checkboxAllAfternoon1;
      let checkAll2 = this.checkboxAllAfternoon2;
      let checkAll3 = this.checkboxAllAfternoon3;
      if (type === 1) {
        if (checkAll1) {
          this.checkboxAllAfternoon2 = false;
          this.checkboxAllAfternoon3 = false;
        }
      } else if (type === 2) {
        if (checkAll2) {
          this.checkboxAllAfternoon1 = false;
          this.checkboxAllAfternoon3 = false;
        }
      } else if (type === 3) {
        if (checkAll3) {
          this.checkboxAllAfternoon1 = false;
          this.checkboxAllAfternoon2 = false;
        }
      }
    },
    /**
     * set unique checkBox header cho các buổi
     */
    setUniquesHeaderEvening(type) {
      let checkAll1 = this.checkboxAllEvening1;
      let checkAll2 = this.checkboxAllEvening2;
      let checkAll3 = this.checkboxAllEvening3;
      if (type === 1) {
        if (checkAll1) {
          this.checkboxAllEvening2 = false;
          this.checkboxAllEvening3 = false;
        }
      } else if (type === 2) {
        if (checkAll2) {
          this.checkboxAllEvening1 = false;
          this.checkboxAllEvening3 = false;
        }
      } else if (type === 3) {
        if (checkAll3) {
          this.checkboxAllEvening1 = false;
          this.checkboxAllEvening2 = false;
        }
      }
    },
    /**
     * check row buổi sáng
     */
    checkRowMorningDay(type, row) {
      let data = row.attendanceArriveKids;
      //đi học
      if (type === 1 && data.morning) {
        data.morningYes = false;
        data.morningNo = false;
      } else if (type === 2 && data.morningYes) {
        //nghỉ có phép
        data.morning = false;
        data.morningNo = false;
      } else if (type === 3 && data.morningNo) {
        //nghỉ không phép
        data.morning = false;
        data.morningYes = false;
      }
      this.setTimeArriveMorningDataMethod(data);
      this.setCheckboxHeaderMorning();
    },

    /**
     * check row buổi chiều
     */
    checkRowAfternoonDay(type, row) {
      let data = row.attendanceArriveKids;
      //đi học
      if (type === 1 && data.afternoon) {
        data.afternoonYes = false;
        data.afternoonNo = false;
      } else if (type === 2 && data.afternoonYes) {
        //nghỉ có phép
        data.afternoon = false;
        data.afternoonNo = false;
      } else if (type === 3 && data.afternoonNo) {
        //nghỉ không phép
        data.afternoon = false;
        data.afternoonYes = false;
      }
      this.setTimeArriveAfternoonDataMethod(data);
      this.setCheckboxHeaderAfternoon();
    },
    /**
     * check row buổi tối
     */
    checkRowEveningDay(type, row) {
      let data = row.attendanceArriveKids;
      //đi học
      if (type === 1 && data.evening) {
        data.eveningYes = false;
        data.eveningNo = false;
      } else if (type === 2 && data.eveningYes) {
        //nghỉ có phép
        data.evening = false;
        data.eveningNo = false;
      } else if (type === 3 && data.eveningNo) {
        //nghỉ không phép
        data.evening = false;
        data.eveningYes = false;
      }
      this.setTimeArriveEveningDataMethod(data);
      this.setCheckboxHeaderEvening();
    },
    /**
     * set giá trị cho phần header các buổi sáng
     */
    setCheckboxHeaderMorning() {
      let dataList = this.attendanceArriveList;
      let countMorning1 = dataList.filter((x) => x.attendanceArriveKids.morning).length;
      this.checkboxAllMorning1 = countMorning1 === dataList.length;
      let countMorning2 = dataList.filter((x) => x.attendanceArriveKids.morningYes)
          .length;
      this.checkboxAllMorning2 = countMorning2 === dataList.length;
      let countMorning3 = dataList.filter((x) => x.attendanceArriveKids.morningNo).length;
      this.checkboxAllMorning3 = countMorning3 === dataList.length;
    },
    /**
     * set giá trị cho phần header các buổi chiều
     */
    setCheckboxHeaderAfternoon() {
      let dataList = this.attendanceArriveList;
      let count1 = dataList.filter((x) => x.attendanceArriveKids.afternoon).length;
      this.checkboxAllAfternoon1 = count1 === dataList.length;
      let count2 = dataList.filter((x) => x.attendanceArriveKids.afternoonYes).length;
      this.checkboxAllAfternoon2 = count2 === dataList.length;
      let count3 = dataList.filter((x) => x.attendanceArriveKids.afternoonNo).length;
      this.checkboxAllAfternoon3 = count3 === dataList.length;
    },
    /**
     * set giá trị cho phần header các buổi tối
     */
    setCheckboxHeaderEvening() {
      let dataList = this.attendanceArriveList;
      let count1 = dataList.filter((x) => x.attendanceArriveKids.evening).length;
      this.checkboxAllEvening1 = count1 === dataList.length;
      let count2 = dataList.filter((x) => x.attendanceArriveKids.eveningYes).length;
      this.checkboxAllEvening2 = count2 === dataList.length;
      let count3 = dataList.filter((x) => x.attendanceArriveKids.eveningNo).length;
      this.checkboxAllEvening3 = count3 === dataList.length;
    },

    /**
     * set các checkbox ở header trong cả ngày
     */
    setAllCheckboxAllDay() {
      let dataList = this.attendanceArriveList;
      let count1 = dataList.filter((x) => x.attendanceArriveKids.allDay).length;
      this.checkboxAllDay1 = count1 === dataList.length;
      let count2 = dataList.filter((x) => x.attendanceArriveKids.allDayYes).length;
      this.checkboxAllDay2 = count2 === dataList.length;
      let count3 = dataList.filter((x) => x.attendanceArriveKids.allDayNo).length;
      this.checkboxAllDay3 = count3 === dataList.length;
    },


    /**
     * set time for orther method
     */
    setTimeArriveDataMethod(data) {
      if (data.morning || data.afternoon || data.evening) {
        data.timeArriveKid = moment(String(new Date())).format("HH:mm");
      } else if (!data.morning && !data.afternoon && !data.evening) {
        data.timeArriveKid = null;
      }
    },

    setTimeArriveMorningDataMethod(data) {
      if (data.morning) {
        data.timeArriveKidMorning = moment(String(new Date())).format("HH:mm");
      } else if (!data.morning) {
        data.timeArriveKidMorning = null;
      }
    },
    changeMorningAttendanceLeave(data) {
      let dataList = this.attendanceDetailDateList;
      dataList.forEach((x) => {
        if (x.attendanceArriveKids.morning) {
          x.attendanceLeaveKids.timeLeaveKidMorning = moment(String(new Date())).format("HH:mm");
        } else if (!data.morning) {
          x.attendanceLeaveKids.timeLeaveKidMorning = null;
        }
      });
    },
    setTimeArriveAfternoonDataMethod(data) {
      if (data.afternoon) {
        data.timeArriveKidAfternoon = moment(String(new Date())).format("HH:mm");
      } else if (!data.morning) {
        data.timeArriveKidAfternoon = null;
      }
    },
    changeAfternoonAttendanceLeave(data) {
      let dataList = this.attendanceDetailDateList;
      dataList.forEach((x) => {
        if (x.attendanceArriveKids.afternoon) {
          x.attendanceLeaveKids.timeLeaveKidAfternoon = moment(String(new Date())).format("HH:mm");
        } else if (!data.afternoon) {
          x.attendanceLeaveKids.timeLeaveKidAfternoon = null;
        }
      });
    },
    setTimeArriveEveningDataMethod(data) {
      if (data.afternoon) {
        data.timeArriveKidEvening = moment(String(new Date())).format("HH:mm");
      } else if (!data.morning) {
        data.timeArriveKidEvening = null;
      }
    },
    changeEveningAttendanceLeave(data) {
      let dataList = this.attendanceDetailDateList;
      dataList.forEach((x) => {
        if (x.attendanceArriveKids.evening) {
          x.attendanceLeaveKids.timeLeaveKidEvening = moment(String(new Date())).format("HH:mm");
        } else if (!data.afternoon) {
          x.attendanceLeaveKids.timeLeaveKidEvening = null;
        }
      });
    },


    /**
     * set thời gian đón muộn
     */
    changeTimeLeave(row) {
      let timeLeave = row.attendanceLeaveKids.timeLeaveKid.split(":");
      let timeConfig = this.configSchoolCommonData.timePickupKid.split(":");
      let hour = timeLeave[0] - timeConfig[0];
      let minute = timeLeave[1] - timeConfig[1];
      let hourLate = hour * 60;
      let minuteLate = hourLate + minute;
      if (minuteLate > 0) {
        row.attendanceLeaveKids.minutePickupLate = minuteLate;
      } else {
        row.attendanceLeaveKids.minutePickupLate = 0;
      }
    },
    getCurrentDate() {
      this.dataSearch.date = moment(String(new Date())).format("YYYY-MM-DD");
    },

    /**
     * đối khối cho tab arrive
     */
    async changeGradeArrive() {
      this.checkAbsentDateInClass("arrive");
    },
    /**
     * đối khối cho tab detail
     */
    async changeGradeLeave() {
      // this.classInGradeMethod();
      this.checkAbsentDateInClass("leave");
    },
    /**
     * đối khối cho tab detail
     */
    async changeGradeEat() {
      this.getSearchAllAttendanceEat();
    },

    /**
     * lấy cấu hình chung
     */
    getConfigCommonMethod() {
      AttendanceService.getConfigCommonForAttendance()
          .then((resp) => {
            this.configSchoolCommonData = resp.data.data;
          })
          .catch((err) => {
            console.log(err);
          });
    },

    /**
     * get data initial
     */
    async fetchDataMany() {
      this.getCurrentDate();
      this.getConfigCommonMethod();
    },
  }
  ,

  beforeMount() {
    this.fetchDataMany();
  }
  ,
}
;
</script>

<style lang="scss" scoped>
/deep/ .el-tabs__nav {
  background: #a0a19ce0;
}

/deep/ .el-icon-loading:before {
  content: "\e6cf";
}

/deep/ .el-loading-spinner .el-loading-text {
  color: #606266;
  font-size: 15px;
}

/deep/ .el-loading-spinner {
  top: 67%;
  width: 100%;
  text-align: center;
  position: absolute;
}

/deep/ .el-tabs__item {
  color: white;
}

/deep/ .el-tabs__item.is-active {
  color: white;
  background: #78a5e7;
}

/deep/ .el-form-item__label {
  font-family: Arial, Helvetica, sans-serif;
}

/deep/ .el-tabs__nav-scroll {
  float: right;
}

/deep/ .el-tabs__header {
  margin-bottom: 0;
}

/deep/ .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border-bottom-color: #78a5e7;
}

/deep/ .el-tabs--card > .el-tabs__header {
  border-bottom: none;
}

/deep/ .el-table th > .cell {
  text-align: center !important;
}

// /deep/.el-table td,
// /deep/.el-table th {
//   padding: 6px 0;
// }
/deep/ .el-table .cell {
  line-height: 15px;
}

/deep/ .el-table th > .cell {
  font-size: 13px;
}

/deep/ .el-checkbox__inner {
  border: 1px solid gray;
}

.input-common {
  margin-right: 5px;
}

.button-bottom {
  border-radius: 0;
  margin-left: 3px;
}

.el-dropdown-menu {
  position: absolute;
  top: 0;
  left: 0;
  padding: 0 0;
  margin: 3px 0;
  background-color: #5fb44a;
  border: 1px solid #ebeef5;
  border-radius: 0;
  box-shadow: 0 2px 12px 0 #0000001a;
}

.el-dropdown-menu li {
  color: white;
  border-top: 1px solid white;
  font-family: Arial, Helvetica, sans-serif;
}

//.second-title {
//  font-size: 10px;
//}

.absent-yes {
  color: #c82ee7;
}

.absent-no {
  color: #e61010;
}
</style>
